import { Input } from "@src/common/components";
import { SIZE } from "baseui/input";

interface PaletteSearchInputProps {
  query: string;
  setQuery: (value: string) => void;
}

export function PaletteSearchInput({ query, setQuery }: PaletteSearchInputProps) {
  return (
    <div className="px-3 py-2 border-b dark:border-gray-700">
      <Input
        size={SIZE.compact}
        autoFocus
        value={query}
        onChange={(e) => setQuery(e.currentTarget.value)}
        placeholder="Search actions..."
      />
    </div>
  );
}
